export const LEGACY_ENVIRONMENTS = {
    production: {
        mainApp: {
            origin: 'www.hapyak.com',
            cdn: 'd2qrdklrsxowl2.cloudfront.net'
        }
    },
    staging: {
        mainApp: {
            origin: 'staging.hapyak.com',
            cdn: 'd3bo0fj9s1pd3n.cloudfront.net'
        }
    },
    feature: {
        mainApp: {
            origin: 'feature.hapyak.com',
            cdn: 'd3g4pn3iuq3qu.cloudfront.net'
        }
    },
    review: {
        mainApp: {
            origin: 'feature.hapyak.com',
            cdn: 'd3g4pn3iuq3qu.cloudfront.net'
        }
    },
    dev: {
        mainApp: {
            origin: 'dev.hapyak.com',
            cdn: 'devcdn.hapyak.com'
        }
    }
};